

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async envioMailDistrito({ commit, dispatch, state }, obj) {
            dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/comunicaciones',
                withCredentials: false,
                data: JSON.stringify(obj),
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                }
            }).then((response) => {
                if (response) {
                    const res = response.data.msg
                    dispatch('notificaciones/showSnack', {
                        message: res,
                        type: "200",
                    }, { root: true })
                } else {
                    dispatch('notificaciones/showSnack', {
                        message: "Error ",
                        type: "400",
                    }, { root: true })
                }
            }).catch(function (error) {
                if (error && error.handledByInterceptor) return
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || 'Error al enviar la comunicación.'
                dispatch('notificaciones/showSnack', {
                    message: msg,
                    type: "400",
                }, { root: true })
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
        async envioMailDistritoConArch({ commit, dispatch, state }, obj) {
            dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/comunicaciones',
                withCredentials: false,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Bearer " + sessionStorage.getItem('token')
                },
                data: obj
            }).then((response) => {
                if (response) {
                    const res = response.data.msg
                    dispatch('notificaciones/showSnack', {
                        message: res,
                        type: "200",
                    }, { root: true })
                } else {
                    dispatch('notificaciones/showSnack', {
                        message: "Error ",
                        type: "400",
                    }, { root: true })
                }
            }).catch(function (error) {
                if (error && error.handledByInterceptor) return
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || 'Error al enviar la comunicación.'
                dispatch('notificaciones/showSnack', {
                    message: msg,
                    type: "400",
                }, { root: true })
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
    },
})